import React from 'react';
import PropTypes from 'prop-types';

import { setCookie, getCookie } from 'utils/cookies';
import { featureFlagsConfig } from 'configs';

import { FeatureFlagsContext } from './';

const FEATURE_FLAGS_COOKIE_NAME = 'ff_overrides';

export class FeatureFlagsContextProvider extends React.Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
	};

	state = {
		featureFlags: null,
	};

	componentDidMount() {
		const urlParams = new URLSearchParams(window.location.search);
		let searchParamsFeatureFlags = {};

		const ffCookies = getCookie(FEATURE_FLAGS_COOKIE_NAME);
		if (ffCookies) {
			try {
				searchParamsFeatureFlags = JSON.parse(ffCookies);
			} catch (e) {
				console.error(`can not parse FF`, e);
			}
		}

		urlParams.forEach(function(value, key) {
			if (key && key.indexOf('FF_') === 0) {
				searchParamsFeatureFlags[key] = value === 'true';
			}
		});

		if (Object.keys(searchParamsFeatureFlags).length > 0) {
			setCookie(
				FEATURE_FLAGS_COOKIE_NAME,
				JSON.stringify(searchParamsFeatureFlags)
			);
		}

		this.setState({
			featureFlags: {
				...featureFlagsConfig,
				...searchParamsFeatureFlags,
			},
		});
	}

	render() {
		return (
			<FeatureFlagsContext.Provider value={this.state}>
				{this.props.children}
			</FeatureFlagsContext.Provider>
		);
	}
}
